import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('student');

export class Invoices extends Api {
  constructor(http, config = {}) {
    super(http, url, 'student', config);
  }

  getInvoicesByMail (mail = null,config = {}) {
    config = {...this._config, ...config};
    const uri = `${url}/invoices?mail=${mail}`
    return this._http.get(uri, config);
  }
}
